import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.js";
import "./styles.css";
import { registerServiceWorker } from "./lib/push.js";

const container = document.getElementById("root");
if (container === null) throw new Error("Element #root ontbreekt in index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/*
 * De service worker maakt de app installeerbaar en handelt meldingen af. Hij
 * wordt na het renderen geregistreerd: mislukt het, dan werkt de webmail gewoon
 * door — alleen offline starten en meldingen vallen dan weg.
 */
void registerServiceWorker();
